import { Chip, Stack, Tooltip, Typography } from "@mui/material";

type TutorCardNameProps = {
  firstName: string;
  lastName: string;
  labels: string[];
};

type ChipType = {
  color: "primary" | "success";
  description: string;
  label: string;
};

const mapLabels = (labels: string[]): ChipType[] => {
  const chips = [];

  labels.forEach((label) => {
    if (label === "Super tutor") {
      chips.push({
        color: "primary",
        description: "This tutor is extremely experienced and highly rated",
        label: label,
      });
    }
    if (label === "Supports SEN") {
      chips.push({
        color: "warning",
        description: "This tutor is trained by us to support students with Special Educational Needs.",
        label: label,
      });
    }
    if (label === "Responds quickly") {
      chips.push({
        color: "success",
        description: "This tutor is quick to respond to new requests",
        label: label,
      });
    }
  });

  return chips;
};

const TutorCardName = ({ firstName, lastName, labels }: TutorCardNameProps) => {
  const chips = mapLabels(labels);

  return (
    <Stack direction={{ xs: "column", xl: "row" }} spacing={1} mb="8px">
      <Typography variant="h3">
        {firstName} {lastName}.
      </Typography>

      {chips.length > 0 && (
        <Stack direction="row" spacing={1} className="tutor-card__labels">
          {chips.map((label) => (
            <Tooltip key={label.label} title={label.description}>
              <Chip size="small" label={label.label} color={label.color}></Chip>
            </Tooltip>
          ))}
        </Stack>
      )}
    </Stack>
  );
};

export default TutorCardName;
